import { UtilityService } from 'src/app/core/services/utility.service';
import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
    name: 'seperateSmsBodyByPart',
    standalone: true
})
export class SeperateSmsBodyByPart implements PipeTransform {

    constructor(private utilityService: UtilityService) {}

    transform(smsBody: any, args?: any): any {

        const udhLen = args;

        const innerHtml = this.utilityService.getSeperatedSmsBodyByPart(smsBody, udhLen)

        return innerHtml;
    }

}
